import { put, call, takeLatest } from 'redux-saga/effects';
import { postRequest } from 'utils/apiRequests';
import { baseURL, endPoints } from 'utils/apiEndpoints';
import {
  UPDATE_HOTEL,
  GET_HOTEL,
} from '../../actionTypes';
import {
  updateHotelSuccess,
  updateHotelFailure,
  getHotelSuccess,
  getHotelFailure,
} from './hotelDetailActions';

function* updateHotel(action) {
  try {
    const { params, headers } = action.payload;
    const url = `${baseURL}${endPoints.updateHotel}`;
    const data = yield call(postRequest, url, params, headers);
    if (data.success) {
      yield put(updateHotelSuccess());
    } else {
      yield put(updateHotelFailure(data.message));
    }
  } catch (err) {
    yield put(updateHotelFailure(err.message));
  }
}

function* getHotel(action) {
  try {
    const { params, headers } = action.payload;
    const url = `${baseURL}${endPoints.getHotelById}`;
    const data = yield call(postRequest, url, params, headers);
    if (data) {
      yield put(getHotelSuccess({ hotel: data, editAllowed: true }));
    } else {
      yield put(getHotelFailure(data.message));
    }
  } catch (err) {
    yield put(getHotelFailure(err.message));
  }
}

export function* updateHotelSaga() {
  yield takeLatest(UPDATE_HOTEL, updateHotel);
}

export function* getHotelSaga() {
  yield takeLatest(GET_HOTEL, getHotel);
}
